import { ProfileType } from '../types/profile';
import { Notifications, Solution } from './../types/solutions';
import axios from '~/utils/axios';
import { Handbook } from '~/types/Handbook';
import { LegalConsentConfiguration } from '~/types/LegalConsent';

export type Feature = {
  key: string;
  name: string;
};

export const getFeaturesRequest = () => {
  return axios.get<Feature[]>(`/features?page=1&perPage=9999`);
};

export type ProfileDetail = {
  id: string;
  type: ProfileType;
  title: string;
  solutionId: string;
  solutionName: string;
};

export const getProfileDetails = (id: string) => {
  return axios.get<ProfileDetail>(`profiles/${id}`);
};

export type Configuration = {
  [x: string]: {
    [x: string]: any;
  };
};

export const getConfiguration = (id: string) => {
  return axios.get<Configuration>(`solutions/${id}/configuration`);
};

export const getLegalConsents = (solutionId: string) => {
  return axios
    .get<LegalConsentConfiguration[]>(`/solutions/${solutionId}/legalConsents`, {
      params: {
        withDeleted: false,
        excludeOneTime: true,
        page: 1,
        perPage: 1000,
      },
    })
    .then((res) => res.data);
};

export const getLegalConsent = (solutionId: string, id: string) => {
  return axios
    .get<LegalConsentConfiguration>(`/solutions/${solutionId}/legalConsents/${id}`)
    .then((res) => res.data);
};

export const getSolutions = () => {
  return axios.get<Solution[]>(`/solutions?page=1&perPage=9999`);
};

export const getSolutionHandbookById = (solutionId: string) => {
  return axios.get<Handbook>(`/solutions/${solutionId}/handbook`).then((res) => res.data);
};

export const getNotifications = (solutionId: string, type: 'transaction' | 'profile') => {
  return axios
    .get<Notifications>(`/solutions/${solutionId}/notifications/${type}`)
    .then((res) => res.data);
};
